import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { FilledButtonComponent, OutlinedButtonComponent } from '@custom-components/general/button';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { DialogShellComponent } from '@custom-components/overlay/dialog-shell/dialog-shell.component';

export interface ConfirmDeactivateFirmwareDialogData {
  version: string;
  filename: string;
}

@Component({
  selector: 'confirm-deactivate-firmware-dialog',
  imports: [
    MatIconModule,
    FilledButtonComponent,
    OutlinedButtonComponent,
    MatDialogModule,
    TranslateModule,
    DialogShellComponent,
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './confirm-deactivate-firmware-dialog.component.html',
})
export class ConfirmDeactivateFirmwareDialogComponent {
  readonly dialogRef = inject(MatDialogRef<ConfirmDeactivateFirmwareDialogComponent>);
  public data = inject<ConfirmDeactivateFirmwareDialogData>(MAT_DIALOG_DATA);

  onConfirm(): void {
    this.dialogRef.close(true);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }
}
